import types from './types';
import { ActionCreators } from 'redux-undo';

export function selectObject(object, size = {}) {
  return {
    type: types.SELECT_OBJECT,
    payload: {
      id: object.id, // for BC
      size: size,
      type: object.type, // for BC
      object: object
    }
  };
}

export function multiSelectObject(id, size = {}) {
  return {
    type: types.SELECT_OBJECT_MULTIPLE,
    payload: {
      id: id,
      size: size
    }
  };
}

export function deselectObjects() {
  return {type: types.DESELECT_OBJECTS};
}

export function toggleGrid() {
  return {type: types.TOGGLE_GRID};
}

export function transformObject(attrs) {
  return {
    type: types.TRANSFORM_OBJECT,
    payload: attrs
  };
}

export function editObject(id, diff) {
  return {
    type: types.EDIT_OBJECT,
    payload: {
      id,
      diff
    }
  }
}

export function editFont(id, diff, font) {
  return {
    type: types.EDIT_FONT,
    payload: {
      id,
      diff,
      font
    }
  }
}

export function moveObject(id, diffX, diffY) {
  return {
    type: types.MOVE_OBJECT,
    payload: { id, diffX, diffY }
  };
}

export function deleteObject(id) {
  return {
    type: types.DELETE_OBJECT,
    payload: { id }
  }
}

export function setZoom(zoom) {
  return {
    type: types.SET_ZOOM,
    payload: {
      zoom: zoom
    }
  };
}

export function undo() {
  return ActionCreators.undo();
}

export function redo() {
  return ActionCreators.redo();
}

export function toggleLayers() {
  return {
    type: types.TOGGLE_LAYERS
  };
}

export function toggleGuide() {
  return {
    type: types.TOGGLE_GUIDE
  };
}

export function sortLayer(oldIndex, newIndex) {
  return {
    type: types.SORT_LAYER,
    payload: {
      newIndex, oldIndex
    }
  };
}

export function addNewText(uuid) {
  return {
    type: types.ADD_NEW_TEXT_OBJECT,
    payload: { uuid }
  }
}

export function addNewImage(object) {
  return {
    type: types.ADD_NEW_IMAGE_OBJECT,
    payload: {
      object
    }
  }
}

export function addNewSticker(sticker) {
  return {
    type: types.ADD_NEW_STICKER_OBJECT,
    payload: {
      sticker
    }
  };
}

export function updateObjectSizes(sizes) {
  return {
    type: types.UPDATE_OBJECT_SIZES,
    payload: { sizes }
  };
}

export function alignHorizontalLeft(ids) {
  return {
    type: types.ALIGN_HORIZONTAL_LEFT,
    payload: { ids }
  };
}

export function alignHorizontalCenter(ids) {
  return {
    type: types.ALIGN_HORIZONTAL_CENTER,
    payload: { ids }
  };
}

export function alignHorizontalRight(ids) {
  return {
    type: types.ALIGN_HORIZONTAL_RIGHT,
    payload: { ids }
  }
}

export function alignVerticalTop(ids) {
  return {
    type: types.ALIGN_VERTICAL_TOP,
    payload: { ids }
  };
}

export function alignVerticalCenter(ids) {
  return {
    type: types.ALIGN_VERTICAL_CENTER,
    payload: { ids }
  };
}

export function alignVerticalBottom(ids) {
  return {
    type: types.ALIGN_VERTICAL_BOTTOM,
    payload: { ids }
  }
}

export function selectPane(type) {
  return {
    type: types.SELECT_PANE,
    payload: {
      type: type
    }
  }
}

export function selectSurface(surface) {
  return {
    type: types.SELECT_SURFACE,
    payload: {
      surface
    }
  }
}

export function selectColor(color) {
  return {
    type: types.SELECT_COLOR,
    payload: {
      color
    }
  }
}

export function changeAmount(id, value) {
  return {
    type: types.CHANGE_AMOUNT,
    payload: { id, value }
  }
}

export function setStickerCategory(category) {
  return {
    type: types.SET_STICKER_CATEGORY,
    payload: {category}
  };
}

export function setSingleMode() {
  return {
    type: types.SET_SINGLE_MODE
  }
}

export function setTeamMode() {
  return {
    type: types.SET_TEAM_MODE
  }
}

export function showTeamModal() {
  return {
    type: types.SHOW_TEAM_MODAL
  }
}

export function hideTeamModal() {
  return {
    type: types.HIDE_TEAM_MODAL
  }
}

export function searchSticker(keyword) {
  return {
    type: types.SEARCH_STICKER,
    payload: { keyword }
  }
}

export function resetStickerKeyword() {
  return {
    type: types.RESET_STICKER_KEYWORD
  }
}

export function fetchStickers(stickers, keyword) {
  return {
    type: types.FETCH_STICKER_SUCCESS,
    payload: { stickers, keyword }
  }
}

export function fetchStickersFailed(err) {
  return {
    type: types.FETCH_STICKER_FAILURE,
    error: err
  }
}

export function showCopyrightModal() {
  return {
    type: types.SHOW_COPYRIGHT_MODAL
  }
}

export function hideCopyrightModal() {
  return {
    type: types.HIDE_COPYRIGHT_MODAL
  };
}

export function toggleLoading(visible) {
  return {
    type: types.TOGGLE_LOADING,
    payload: { visible }
  }
}

export function copyObject(object, uuid) {
  return {
    type: types.COPY_OBJECT,
    payload: { object, uuid }
  }
}

export function flipHorizontal(id) {
  return {
    type: types.FLIP_OBJECT_HORIZONTAL,
    payload: { id }
  }
}

export function flipVertical(id) {
  return {
    type: types.FLIP_OBJECT_VERTICAL,
    payload: { id }
  }
}

export function selectTemplateObject(index) {
  return {
    type: types.SELECT_TEMPLATE_OBJECT,
    payload: { index },
  }
}

export function addNewTemplateText(id, uuid, props) {
  return {
    type: types.ADD_NEW_TEMPLATE_TEXT,
    payload: { id, uuid, props }
  }
}

export function updateTemplateText(id, props) {
  return {
    type: types.UPDATE_TEMPLATE_TEXT,
    payload: { id, props }
  }
}

export function addNewTemplateImage(id, uuid, props, name) {
  return {
    type: types.ADD_NEW_TEMPLATE_IMAGE,
    payload: { id, uuid, props, name }
  };
}

export function updateTemplateImage(id, props) {
  return {
    type: types.UPDATE_TEMPLATE_IMAGE,
    payload: { id, props }
  }
}

export function deleteTemplateObject(id) {
  return {
    type: types.DELETE_TEMPLATE_OBJECT,
    payload: { id }
  }
}

export function addNewTemplate(template) {
  return {
    type: types.ADD_NEW_TEMPLATE,
    payload: { template }
  }
}

/* For backward compatibility */
export function addNewTemplateObject(id, props) {
  return {
    type: types.ADD_TEMPLATE_OBJECT,
    payload: { id, props }
  }
}

/* For backward compatibility */
export function updateTemplateObject(id, props) {
  return {
    type: types.UPDATE_TEMPLATE_OBJECT,
    payload: { id, props },
    index: id //FIXME: For backward compatibility
  }
}





// WEBPACK FOOTER //
// ./src/actions/index.js